import {FC} from 'react'
import {SUB_STRING_METHOD} from 'interfaces'
import {RenderIf} from '../RenderIf'
import {checkTextOverflowed, stringSplitAndJoin} from 'utils'

interface Props {
  textColor?: string
  subString: string
  data: string
  method?: SUB_STRING_METHOD
  classNames?: string
}

export const ColorSubstring: FC<Props> = ({
  subString = '',
  data = '',
  method = SUB_STRING_METHOD.StartsWith,
  classNames = '',
}) => {
  // these const are used for includes method substring
  const indexOfSubstring = data?.toLowerCase().indexOf(subString?.toLowerCase())
  let firstPartOfString, middlePartOfString, endPartOfString
  // this condition true means substring is matching with data
  if (indexOfSubstring >= 0) {
    firstPartOfString = data.slice(0, indexOfSubstring)
    middlePartOfString = data.slice(
      indexOfSubstring,
      indexOfSubstring + subString.length,
    )
    endPartOfString = data.slice(indexOfSubstring + subString.length)
  } else {
    firstPartOfString = ''
    middlePartOfString = ''
    endPartOfString = data
  }

  // these const are used for startsWith method substring
  const getSelectedSubstring = (): string => {
    return data.slice(0, subString.length)
  }

  const getUnSelectedSubstring = (): string => {
    return data.slice(subString.length, data.length)
  }

  return (
    <p
      className={`truncate ${classNames}`}
      role="button"
      tabIndex={0}
      onMouseOver={checkTextOverflowed}
      onKeyDown={checkTextOverflowed}
      data-cy={`color-substring-${stringSplitAndJoin(data?.toLowerCase())}`}
    >
      <RenderIf isTrue={method === SUB_STRING_METHOD.StartsWith}>
        <>
          {indexOfSubstring === 0 ? (
            <>
              <span className="text-dope-cyan-dark">
                {getSelectedSubstring()}
              </span>
              {getUnSelectedSubstring()}
            </>
          ) : (
            data
          )}
        </>
      </RenderIf>
      <RenderIf isTrue={method === SUB_STRING_METHOD.Includes}>
        <>
          {firstPartOfString}
          <span className="text-dope-cyan-dark">{middlePartOfString}</span>
          {endPartOfString}
        </>
      </RenderIf>
    </p>
  )
}
